import { RouteConfig } from "vue-router";

const routes: Array<RouteConfig> = [
  {
    path: "/perfil/alterar-senha",
    name: "AlterarSenha",
    component: () =>
      import(
        /* webpackChunkName: "perfil" */ "@/views/private/perfil/AlterarSenha.vue"
      ),
  },
];

export default routes;
